import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, saveSession } from "./adminApi";

const shell = {
  minHeight: "100vh", background: "#0F1B2D",
  display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
  padding: "32px 16px", boxSizing: "border-box",
};
const card = {
  width: 380, maxWidth: "100%", background: "white", borderRadius: 12,
  border: "1px solid #1E3A5F", padding: 32,
  boxShadow: "0 10px 32px rgba(0,0,0,0.3)",
};
const input = {
  width: "100%", height: 44, border: "1px solid #D1D5DB", borderRadius: 8,
  padding: "0 12px", fontSize: 14, outline: "none", boxSizing: "border-box",
};

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await adminApi.login(username.trim(), password);
    setLoading(false);
    if (res.ok && res.data?.token) {
      saveSession(res.data.token);
      navigate("/admin/dashboard");
    } else {
      setErr("Invalid credentials");
    }
  };

  return (
    <div data-testid="admin-login-page" style={shell}>
      <div style={{ marginBottom: 24, textAlign: "center" }}>
        <div style={{ fontSize: 26, fontWeight: 700 }}>
          <span style={{ color: "#ffffff" }}>C-ORE</span>
        </div>
        <div style={{ width: 36, height: 2, background: "#10b981", marginTop: 4, marginLeft: "auto", marginRight: "auto" }} />
        <div style={{ color: "#94a3b8", marginTop: 8, fontSize: 12, letterSpacing: 1, textTransform: "uppercase" }}>Admin panel</div>
      </div>

      <form style={card} onSubmit={onSubmit}>
        <h2 style={{ color: "#1E3A5F", fontSize: 18, fontWeight: 700, margin: 0, marginBottom: 4 }}>Sign in</h2>
        <p style={{ color: "#6B7280", fontSize: 12, marginTop: 0, marginBottom: 18 }}>Authorized personnel only</p>

        <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>Username</label>
        <input data-testid="admin-username" autoFocus value={username} onChange={(e) => setUsername(e.target.value)}
               placeholder="coreai_admin" autoComplete="username" style={input} />

        <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginTop: 14, marginBottom: 6 }}>Password</label>
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
               placeholder="••••••••" autoComplete="current-password" style={input} />

        {err && <p data-testid="admin-login-error" style={{ color: "#DC2626", fontSize: 13, marginTop: 12, marginBottom: 0 }}>{err}</p>}

        <button data-testid="admin-signin" type="submit" disabled={loading}
          style={{
            width: "100%", marginTop: 18, height: 44,
            background: loading ? "#334155" : "#1E3A5F", color: "white",
            border: "none", borderRadius: 8, fontWeight: 700, fontSize: 14,
            cursor: loading ? "default" : "pointer",
          }}>
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>

      <div style={{ marginTop: 16, color: "#475569", fontSize: 11 }}>
        Forgot credentials? Contact support@c-ore.in
      </div>
    </div>
  );
}
